export default "__VITE_PUBLIC_ASSET__1bb3a4f7__"